import authImg from "./authImg.svg";
import trans1 from "./trans1.svg";
import trans2 from "./trans2.svg";
import trans3 from "./trans3.svg";
import trans4 from "./trans4.svg";
import trans5 from "./trans5.svg";
import trans6 from "./trans6.svg";
import trans7 from "./trans7.svg";
import trans8 from "./trans8.svg";
import trans9 from "./trans9.svg";
import trans10 from "./trans10.svg";
import trans11 from "./trans11.svg";
import trans12 from "./trans12.svg";
import UP from "./up.png";
export {
  authImg,
  trans1,
  trans2,
  trans3,
  trans4,
  trans5,
  trans6,
  trans7,
  trans8,
  trans9,
  trans10,
  trans11,
  trans12,
  UP
};